export function toNumber(
  value?: string | number | null,
  defaultValue: number = 0
): number {
  if (typeof value === "number") {
    return value
  }

  if (!value) {
    return defaultValue
  }

  if (Number.isNaN(parseInt(value, 10))) {
    return defaultValue
  }

  if (Number.isSafeInteger(parseInt(value, 10))) {
    return parseInt(value, 10)
  }
  return defaultValue
}
